(function (root, factory) {
  'use strict';

  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.FleurySearchFormatIntent = api;
  if (root && root.document) api.init(root);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var SEARCH_INPUT_SELECTOR = 'input[type="search"],input[name="q"],input[data-search-input],input[data-fa-search-query],input.snize-input-style';
  var lastInputs = new WeakMap();
  var routeAliases = new WeakMap();

  // One decorative icon vocabulary for categories and configurators. Text
  // labels remain the accessible name, independent of the active language.
  function createIcon(documentObject, kind) {
    var shapes = {
      canvas: [['rect',{x:10,y:8,width:28,height:32,rx:1}],['path',{d:'M10 32 29 13M19 40 38 21',opacity:'.45'}],['path',{d:'M6 12V5h7M35 43h7v-7',stroke:'#ff8900'}]],
      gallery: [['path',{d:'M9 10h27v29H9ZM36 10l5-5v29l-5 5M9 10l5-5h27'}],['path',{d:'m28 7 6-2M38 18l3-3',stroke:'#ff8900'}]],
      studio: [['path',{d:'M9 9h29v31H9ZM38 9l3-3v31l-3 3M9 9l3-3h29'}],['path',{d:'M15 34 31 18',opacity:'.45'}],['path',{d:'M5 13V5h8',stroke:'#ff8900'}]],
      round: [['circle',{cx:24,cy:24,r:17}],['circle',{cx:24,cy:24,r:13,opacity:'.4'}],['path',{d:'M7 24h34M7 20v8M41 20v8',stroke:'#ff8900'}]],
      bars: [['path',{d:'M8 8h32v32H8ZM14 14h20v20H14ZM8 8l6 6M40 8l-6 6M8 40l6-6M40 40l-6-6'}],['path',{d:'M15 6h18M6 15v18',stroke:'#ff8900'}]],
      shadow: [['rect',{x:6,y:6,width:36,height:36,rx:1}],['rect',{x:13,y:12,width:22,height:25,rx:1}],['path',{d:'M9 15v18M38 15v18',stroke:'#ff8900'}]],
      kit: [['path',{d:'M6 18V6h12M30 6h12v12M42 30v12H30M18 42H6V30M12 18v-6h6M30 12h6v6M36 30v6h-6M18 36h-6v-6'}],['path',{d:'M20 24h8m-4-4v8',stroke:'#ff8900'}]],
      picture: [['path',{d:'M6 6h36v36H6ZM12 12h24v24H12ZM6 6l6 6M42 6l-6 6M6 42l6-6M42 42l-6-6'}],['path',{d:'m16 30 7-8 5 5 4-4',stroke:'#ff8900'}]],
      mat: [['rect',{x:6,y:6,width:36,height:36,rx:1}],['rect',{x:15,y:12,width:18,height:23}],['path',{d:'M10 16v-6h6M32 38h6v-6',stroke:'#ff8900'}]],
    }[kind];
    if (!shapes) return null;
    var svg = documentObject.createElementNS('http://www.w3.org/2000/svg','svg');
    var attributes = {viewBox:'0 0 48 48',fill:'none',stroke:'currentColor','stroke-width':'2.3','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false','data-fa-search-icon':kind};
    Object.keys(attributes).forEach(function(key){svg.setAttribute(key,attributes[key]);});
    shapes.forEach(function(shape){var el=documentObject.createElementNS('http://www.w3.org/2000/svg',shape[0]);Object.keys(shape[1]).forEach(function(key){el.setAttribute(key,shape[1][key]);});svg.appendChild(el);});
    return svg;
  }

  function iconKindForDocument(item) {
    var key = String(item && item.key || '').replace(/^\/(?:de|en|fr|it)(?=\/)/,'');
    if (/\/(?:pages|collections)\/keilrahmenleisten(?:-|\/|$)/.test(key)) return 'bars';
    if (/\/collections\/galerie-keilrahmen(?:\/|$)/.test(key)) return 'gallery';
    if (/\/pages\/bespannte-keilrahmen(?:\/|$)/.test(key)) return 'canvas';
    if (/\/pages\/schattenfugen-auf-mass(?:\/|$)/.test(key)) return 'shadow';
    if (/\/pages\/rahmen-stecksystem(?:\/|$)/.test(key)) return 'kit';
    if (/\/pages\/passepartout-konfigurator(?:\/|$)/.test(key)) return 'mat';
    if (/\/pages\/(?:rahmen|bilderrahmen-auf-mass)(?:\/|$)/.test(key)) return 'picture';
    return null;
  }

  var FORMAT_WORDS = [
    'keilrahmen',
    'leinwand',
    'leinwandbild',
    'schattenfuge',
    'schattenfugenrahmen',
    'rahmen',
    'canvas',
    'stretcher',
    'floating frame',
    'frame',
    'toile',
    'châssis',
    'chassis',
    'caisse américaine',
    'caisse americaine',
    'cadre',
    'tela',
    'telaio',
    'cornice',
    'passepartout',
    'passe-partout',
    'mount board',
    'mat board',
  ];
  var ROUND_WORDS = [
    'rund',
    'round',
    'circular',
    'rond',
    'ronde',
    'circulaire',
    'tondo',
    'rotondo',
    'circolare',
    'durchmesser',
    'diameter',
    'diamètre',
    'diametro',
  ];
  var COPY = {
    de: {
      matched: 'Passend zu {format} cm',
      roundMatched: 'Passend zu Ø {format} cm',
      gallery: 'Galerie-Keilrahmen',
      studio: 'Keilrahmen 2 cm',
      shadow: 'Schattenfugenrahmen',
      bars: 'Keilrahmenleisten-Set 4 cm · ohne Leinwand',
      round: 'Runder Keilrahmen',
      available: 'verfügbar',
      unavailable: 'derzeit nicht verfügbar',
      choose: 'Varianten auswählen',
      noRound: 'Ein runder Keilrahmen mit diesem Durchmesser ist derzeit nicht verfügbar.',
      noStandard: 'Kein Standardprodukt in diesem Format. Entdecke die passenden Konfiguratoren darunter.',
    },
    en: {
      matched: 'Matches for {format} cm',
      roundMatched: 'Matches for Ø {format} cm',
      gallery: 'Gallery canvas',
      studio: '2 cm canvas',
      shadow: 'Floating frame',
      bars: '4 cm stretcher frame kit · without canvas',
      round: 'Round canvas',
      available: 'available',
      unavailable: 'currently unavailable',
      choose: 'Choose options',
      noRound: 'A round canvas with this diameter is currently unavailable.',
      noStandard: 'No standard product in this size. Explore the matching configurators below.',
    },
    fr: {
      matched: 'Résultats pour {format} cm',
      roundMatched: 'Résultats pour Ø {format} cm',
      gallery: 'Châssis galerie',
      studio: 'Châssis 2 cm',
      shadow: 'Caisse américaine',
      bars: 'Kit de châssis 4 cm · sans toile',
      round: 'Châssis rond',
      available: 'disponible',
      unavailable: 'actuellement indisponible',
      choose: 'Choisir les options',
      noRound: 'Un châssis rond de ce diamètre n’est pas disponible actuellement.',
      noStandard: 'Aucun produit standard dans ce format. Découvrez les configurateurs adaptés ci-dessous.',
    },
    it: {
      matched: 'Risultati per {format} cm',
      roundMatched: 'Risultati per Ø {format} cm',
      gallery: 'Telaio galleria',
      studio: 'Telaio 2 cm',
      shadow: 'Cornice a cassetta',
      bars: 'Kit telaio 4 cm · senza tessuto',
      round: 'Telaio tondo',
      available: 'disponibile',
      unavailable: 'attualmente non disponibile',
      choose: 'Scegli le opzioni',
      noRound: 'Un telaio tondo con questo diametro non è attualmente disponibile.',
      noStandard: 'Nessun prodotto standard in questo formato. Scopri i configuratori adatti qui sotto.',
    },
  };

  function init(windowObject) {
    if (windowObject.__fleurySearchFormatIntentInitialized) return;
    windowObject.__fleurySearchFormatIntentInitialized = true;
    var documentObject = windowObject.document;
    var locale = normalizeLocale(documentObject.documentElement.lang);
    var catalog = windowObject.FleurySearchFormatCatalog || { rectangles: {}, rounds: {} };
    var scanTimer = null;

    function scheduleScan() {
      windowObject.clearTimeout(scanTimer);
      scanTimer = windowObject.setTimeout(scan, 50);
    }

    function scan() {
      var locationQuery = readPageQuery(windowObject);
      var inputQuery = activeSearchQuery(documentObject, windowObject);
      locale = normalizeLocale(documentObject.documentElement.lang);
      catalog = windowObject.FleurySearchFormatCatalog || { rectangles: {}, rounds: {} };
      renderResultsIntent(documentObject, catalog, locale, locationQuery, windowObject);
      renderInstantIntent(documentObject, catalog, locale, inputQuery, windowObject);
    }

    if (documentObject.readyState === 'loading') {
      documentObject.addEventListener('DOMContentLoaded', scan, { once: true });
    } else {
      scan();
    }
    new windowObject.MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) { return !isOwnedMutation(mutation); })) scheduleScan();
    }).observe(documentObject.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden'],
    });
    function inputChanged(event) {
      rememberSearchInput(documentObject, event.target);
      scheduleScan();
    }
    documentObject.addEventListener('input', inputChanged, true);
    documentObject.addEventListener('focusin', inputChanged, true);
    windowObject.addEventListener('popstate', scheduleScan);
    windowObject.addEventListener('fa:search-updated', scheduleScan);
  }

  function parseFormatIntent(query) {
    var source = normalizeText(query);
    if (!source) return null;

    var diameterMatch = source.match(/(?:ø|⌀|durchmesser|diameter|diamètre|diametro)\s*[:=]?\s*(\d+(?:[.,]\d+)?)\s*(mm|cm)?/i);
    if (!diameterMatch) {
      var roundWord = ROUND_WORDS.some(function (word) { return source.indexOf(word) !== -1; });
      if (roundWord) diameterMatch = source.match(/(\d+(?:[.,]\d+)?)\s*(mm|cm)?/i);
    }
    if (diameterMatch) {
      var diameter = toCentimetres(diameterMatch[1], diameterMatch[2]);
      if (validDimension(diameter)) {
        return {
          kind: 'round',
          diameter: diameter,
          key: formatNumber(diameter),
          display: formatNumber(diameter),
          original: String(query || ''),
        };
      }
    }

    var explicitMatch = source.match(
      /(\d+(?:[.,]\d+)?)\s*(mm|cm)?\s*(?:x|×|✕|\*|mal|by|par|per)\s*(\d+(?:[.,]\d+)?)\s*(mm|cm)?/i,
    );
    var punctuationMatch = explicitMatch ? null : source.match(
      /(\d+(?:[.,]\d+)?)\s*(mm|cm)?\s*([/:\-–—])\s*(\d+(?:[.,]\d+)?)\s*(mm|cm)?/i,
    );
    var match = explicitMatch || punctuationMatch;
    if (!match) return null;

    if (punctuationMatch) {
      var withoutMatch = source.replace(punctuationMatch[0], '').replace(/\b(?:mm|cm)\b/g, '').trim();
      var hasProductIntent = FORMAT_WORDS.some(function (word) { return source.indexOf(word) !== -1; });
      if (withoutMatch && !hasProductIntent) return null;
    }

    var first;
    var second;
    if (explicitMatch) {
      first = toCentimetres(explicitMatch[1], explicitMatch[2] || explicitMatch[4]);
      second = toCentimetres(explicitMatch[3], explicitMatch[4] || explicitMatch[2]);
    } else {
      first = toCentimetres(punctuationMatch[1], punctuationMatch[2] || punctuationMatch[5]);
      second = toCentimetres(punctuationMatch[4], punctuationMatch[5] || punctuationMatch[2]);
    }
    if (!validDimension(first) || !validDimension(second)) return null;

    var dimensions = [first, second].sort(function (left, right) { return left - right; });
    return {
      kind: 'rectangle',
      short: dimensions[0],
      long: dimensions[1],
      key: formatNumber(dimensions[0]) + 'x' + formatNumber(dimensions[1]),
      display: formatNumber(dimensions[0]) + ' × ' + formatNumber(dimensions[1]),
      original: String(query || ''),
    };
  }

  function buildConfiguratorUrl(rootUrl, intent) {
    if (!intent || intent.kind !== 'rectangle') return '';
    if (!isCustomEligible(intent)) return '';
    var base = String(rootUrl || '/');
    if (base.charAt(base.length - 1) !== '/') base += '/';
    var url = new URL(base + 'pages/bespannte-keilrahmen', 'https://fleury.invalid');
    if (intent.long > 195) {
      // The extended range is gallery/4 cm only. The legacy length/width
      // interface defaults to 2 cm and must not receive these large formats.
      url.searchParams.set('kc_type', 'custom_4cm');
      url.searchParams.set('kc_length', formatNumber(intent.long));
      url.searchParams.set('kc_width', formatNumber(intent.short));
      url.searchParams.set('kc_custom', '1');
    } else {
      url.searchParams.set('length', formatNumber(intent.long));
      url.searchParams.set('width', formatNumber(intent.short));
      url.searchParams.set('include_custom', '1');
    }
    url.searchParams.set('source', 'search');
    return url.pathname + url.search;
  }

  function isCustomEligible(intent, thicknessCm) {
    var profile = thicknessCm === undefined
      ? (/(?:^|\s)2\s*cm(?:\s|$)/i.test(String(intent && intent.original || '')) ? 2 : 4)
      : thicknessCm;
    if (profile !== 2 && profile !== 4) return false;
    return Boolean(
      intent
      && intent.kind === 'rectangle'
      && Number.isInteger(intent.short)
      && Number.isInteger(intent.long)
      && intent.short >= 15
      && intent.short <= 195
      && intent.long >= 15
      && intent.long >= intent.short
      && intent.long <= (profile === 2 ? 195 : 300),
    );
  }

  function renderResultsIntent(documentObject, catalog, locale, query, windowObject) {
    var existing = documentObject.querySelector('.fa-search-format-intent--results');
    var intent = parseFormatIntent(query);
    if (!intent) {
      if (existing) existing.remove();
      return;
    }

    var mount = documentObject.querySelector('[data-fa-search-recommendations]');
    if (!mount) return;
    if (existing && existing.dataset.intentKey === intent.kind + ':' + intent.key && existing.dataset.locale === locale && existing.parentNode === mount) return;
    if (existing) existing.remove();

    var block = buildIntentBlock(documentObject, catalog, locale, intent, windowObject, false);
    block.classList.add('fa-search-format-intent--results');
    mount.insertBefore(block, mount.firstChild);
  }

  function renderInstantIntent(documentObject, catalog, locale, query, windowObject) {
    var content = ensureOwnedInstantMount(documentObject);
    var existing = documentObject.querySelector('#snize-instant-search-results .fa-search-format-intent--instant');
    var intent = parseFormatIntent(query);
    if (!content || !intent) {
      if (existing) existing.remove();
      return;
    }
    if (existing && existing.dataset.intentKey === intent.kind + ':' + intent.key && existing.dataset.locale === locale && existing.parentNode === content) {
      if (content.firstChild !== existing) content.insertBefore(existing, content.firstChild);
      return;
    }
    if (existing) existing.remove();

    var block = buildIntentBlock(documentObject, catalog, locale, intent, windowObject, true);
    block.classList.add('fa-search-format-intent--instant');
    content.insertBefore(block, content.firstChild);
  }

  function buildIntentBlock(documentObject, catalog, locale, intent, windowObject, compact) {
    var copy = COPY[locale] || COPY.de;
    var block = documentObject.createElement('section');
    block.className = 'fa-search-format-intent';
    block.dataset.faSearchOwned = 'format';
    block.dataset.intentKey = intent.kind + ':' + intent.key;
    block.dataset.locale = locale;

    var heading = documentObject.createElement(compact ? 'strong' : 'h2');
    heading.className = 'fa-search-format-intent__heading';
    heading.textContent = interpolate(intent.kind === 'round' ? copy.roundMatched : copy.matched, {
      format: intent.display,
    });
    block.appendChild(heading);

    var matches = intent.kind === 'round'
      ? { round: (catalog.rounds && catalog.rounds[intent.key]) || [] }
      : (catalog.rectangles && catalog.rectangles[intent.key]) || { gallery: [], studio: [], shadow: [] };
    var links = documentObject.createElement('div');
    links.className = 'fa-search-format-intent__links';

    var ordered = [];
    (intent.kind === 'round' ? ['round'] : ['gallery', 'studio', 'shadow', 'bars']).forEach(function (family) {
      (matches[family] || []).forEach(function (entry) { ordered.push({ entry: entry, label: copy[family] }); });
    });
    ordered.sort(function (left, right) { return Number(right.entry.available) - Number(left.entry.available); });
    ordered.forEach(function (match) {
      appendProductLinks(documentObject, links, [match.entry], match.label, localeRoot(windowObject), locale, copy, windowObject.FleurySearchConfig);
    });
    if (links.childNodes.length) block.appendChild(links);

    if (intent.kind === 'round' && !(matches.round || []).length) {
      var noRound = documentObject.createElement('p');
      noRound.className = 'fa-search-format-intent__note';
      noRound.textContent = copy.noRound;
      block.appendChild(noRound);
    }

    if (intent.kind === 'rectangle' && !links.childNodes.length) {
      var noStandard = documentObject.createElement('p');
      noStandard.className = 'fa-search-format-intent__note';
      noStandard.textContent = copy.noStandard;
      block.appendChild(noStandard);
    }
    return block;
  }

  function appendProductLinks(documentObject, container, entries, label, rootUrl, locale, copy, config) {
    entries
      .slice()
      .sort(function (left, right) { return Number(right.available) - Number(left.available); })
      .forEach(function (entry) {
        var link = documentObject.createElement('a');
        link.href = buildProductUrl(rootUrl, entry, locale, config);
        link.className = 'fa-search-format-intent__product' + (entry.available ? '' : ' is-unavailable');

        var name = documentObject.createElement('strong');
        name.textContent = label;
        var symbol = createIcon(documentObject, entry.family || (entry.handle && /rund|round/.test(entry.handle) ? 'round' : 'canvas'));
        if (symbol) { var graphic = documentObject.createElement('span'); graphic.className = 'fa-search-format-intent__icon'; graphic.appendChild(symbol); link.appendChild(graphic); }
        var status = documentObject.createElement('span');
        status.className = 'fa-search-format-intent__status';
        status.textContent = entry.available ? copy.available : copy.unavailable;
        if (entry.variantIds && entry.variantIds.length > 1) status.textContent += ' · ' + copy.choose;
        link.appendChild(name);
        link.appendChild(status);
        container.appendChild(link);
      });
  }

  function buildProductUrl(rootUrl, entry, locale, config) {
    var handle = resolveProductHandle(entry, locale, config);
    if (!handle) return '';
    var base = String(rootUrl || '/');
    if (base.charAt(base.length - 1) !== '/') base += '/';
    var path = 'products/' + encodeURIComponent(handle);
    return base + path + (entry.variantId ? '?variant=' + encodeURIComponent(entry.variantId) : '');
  }

  function resolveProductHandle(entry, locale, config) {
    if (!entry) return '';
    if (typeof entry === 'string') entry = { handle: entry };
    config = config || (typeof window !== 'undefined' && window.FleurySearchConfig) || {};
    var routes = config.productRoutes;
    var sourceHandle = String(entry.handle || '').trim();
    var handles = entry.handles;
    if (routes && typeof routes === 'object') {
      var aliases = routeAliases.get(routes);
      if (!aliases) {
        aliases = Object.create(null);
        Object.keys(routes).forEach(function (source) {
          aliases[source] = source;
          Object.keys(routes[source] || {}).forEach(function (language) {
            var alias = routes[source][language];
            if (typeof alias === 'string' && alias) aliases[alias] = source;
          });
        });
        routeAliases.set(routes, aliases);
      }
      sourceHandle = aliases[sourceHandle] || sourceHandle;
      handles = routes[sourceHandle] || handles;
    }
    var localizedHandle = handles && handles[normalizeLocale(locale)];
    return String(localizedHandle || sourceHandle).trim();
  }

  function readPageQuery(windowObject) {
    try {
      return new URL(windowObject.location.href).searchParams.get('q') || '';
    } catch (error) {
      return '';
    }
  }

  function rememberSearchInput(documentObject, input) {
    if (input && input.matches && input.matches(SEARCH_INPUT_SELECTOR)) lastInputs.set(documentObject, input);
  }

  function usableInput(input, windowObject) {
    if (!input || input.isConnected === false) return false;
    if (input.getClientRects && !input.getClientRects().length) return false;
    if (windowObject && windowObject.getComputedStyle) {
      var style = windowObject.getComputedStyle(input);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
  }

  function activeSearchQuery(documentObject, windowObject) {
    var active = documentObject.activeElement;
    if (active && active.matches && active.matches(SEARCH_INPUT_SELECTOR)) {
      rememberSearchInput(documentObject, active);
      return active.value || '';
    }
    // Mobile Searchanise creates a plain text input without type or name. Keep
    // using it while focus moves from that input to a recommendation or filter.
    var mobile = documentObject.querySelector('#snize-mobile-search-input');
    if (usableInput(mobile, windowObject)) return mobile.value || '';
    var remembered = lastInputs.get(documentObject);
    if (usableInput(remembered, windowObject)) return remembered.value || '';
    var inputs = Array.prototype.slice.call(
      documentObject.querySelectorAll(SEARCH_INPUT_SELECTOR),
    );
    for (var index = 0; index < inputs.length; index += 1) {
      if (usableInput(inputs[index], windowObject)) return inputs[index].value || '';
    }
    return '';
  }

  function queryForNode(node, windowObject) {
    if (node && node.closest && node.closest('#snize-instant-search-results, .fa-search-standalone')) {
      return activeSearchQuery(windowObject.document || node.ownerDocument, windowObject);
    }
    return readPageQuery(windowObject);
  }

  function ensureOwnedInstantMount(documentObject) {
    var content = documentObject.querySelector('#snize-instant-search-results .snize-ac-results-content');
    if (!content) return null;
    var mount = content.querySelector('.fa-search-instant-owned');
    if (!mount) {
      mount = documentObject.createElement('div');
      mount.className = 'fa-search-instant-owned';
      mount.dataset.faSearchOwned = 'instant';
    }
    var mobileTop = content.querySelector('.snize-mobile-top-panel');
    // Preserve Searchanise's sticky search/back panel and delegated controls.
    var before = mobileTop && mobileTop.parentNode === content ? mobileTop.nextSibling : content.firstChild;
    if (before !== mount) content.insertBefore(mount, before);
    return mount;
  }

  function isOwnedMutation(mutation) {
    var target = mutation && mutation.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    return Boolean(target && target.closest && target.closest('[data-fa-search-owned]'));
  }

  function localeRoot(windowObject) {
    var configured = windowObject.Shopify
      && windowObject.Shopify.routes
      && windowObject.Shopify.routes.root;
    if (configured) return configured;
    var locale = normalizeLocale(windowObject.document.documentElement.lang);
    return locale === 'de' ? '/' : '/' + locale + '/';
  }

  function normalizeLocale(value) {
    var locale = String(value || 'de').toLowerCase().split('-')[0];
    return COPY[locale] ? locale : 'de';
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function toCentimetres(value, unit) {
    var number = Number(String(value || '').replace(',', '.'));
    if (!Number.isFinite(number)) return NaN;
    return String(unit || '').toLowerCase() === 'mm' ? number / 10 : number;
  }

  function validDimension(value) {
    return Number.isFinite(value) && value >= 1 && value <= 300;
  }

  function formatNumber(value) {
    return Number.isInteger(value) ? String(value) : String(Number(value.toFixed(2)));
  }

  function interpolate(value, replacements) {
    return String(value || '').replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(replacements, key) ? replacements[key] : match;
    });
  }

  return {
    createIcon: createIcon,
    iconKindForDocument: iconKindForDocument,
    buildConfiguratorUrl: buildConfiguratorUrl,
    buildProductUrl: buildProductUrl,
    buildIntentBlock: buildIntentBlock,
    init: init,
    isCustomEligible: isCustomEligible,
    parseFormatIntent: parseFormatIntent,
    resolveProductHandle: resolveProductHandle,
    SEARCH_INPUT_SELECTOR: SEARCH_INPUT_SELECTOR,
    activeSearchQuery: activeSearchQuery,
    readPageQuery: readPageQuery,
    queryForNode: queryForNode,
    rememberSearchInput: rememberSearchInput,
    ensureOwnedInstantMount: ensureOwnedInstantMount,
    isOwnedMutation: isOwnedMutation,
  };
});
